import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { resetAllStores, resetPlanScopedStores } from '../sharedActions';
import {
  getRequerimentosStatus,
  getRequerimentosForms,
  getRequerimentosPeritos,
  enviarRequerimentoFormulario,
  criarRascunhoRequerimento,
  adicionarItemRascunhoRequerimento,
  atualizarItemRascunhoRequerimento,
  excluirItemRascunhoRequerimento,
  concluirEnvioRequerimento,
} from './thunks';

const requerimentosSlice = createSlice({
  name: 'requerimentos',
  initialState,
  reducers: {
    setDadosPessoaisRequerimento: (state, { payload }) => {
      state.dadosPessoaisRequerimento = {
        ...state.dadosPessoaisRequerimento,
        ...payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllStores, () => initialState);
    builder.addCase(resetPlanScopedStores, () => initialState);

    builder.addCase(getRequerimentosStatus.pending, (state) => {
      state.loadingStatus = true;
    });

    builder.addCase(
      getRequerimentosStatus.fulfilled,
      (state, { payload: { status, data } }) => {
        let mappedStatus = status;

        if (status === 'em andamento') {
          mappedStatus = 'emAndamento';
        } else if (status === 'Pendente Correção') {
          mappedStatus = 'pendenteCorrecao';
        }

        state[mappedStatus] = data;
        state.allFormsByStatusDone = {
          ...state.allFormsByStatusDone,
          [status]: true,
        };
        state.loadingStatus = false;
      }
    );

    builder.addCase(getRequerimentosStatus.rejected, (state) => {
      state.loadingStatus = false;
    });

    builder.addCase(getRequerimentosForms.pending, (state) => {
      state.loadingForms = true;
      state.allFormsRequestDone = false;
    });

    builder.addCase(
      getRequerimentosForms.fulfilled,
      (state, { payload: { forms, formLabels } }) => {
        state.allForms = forms;
        state.allFormsRequestDone = true;
        state.allFormsLabels = formLabels;
        state.allFormsLabelsRequestDone = true;
        state.loadingForms = false;
      }
    );

    builder.addCase(getRequerimentosForms.rejected, (state) => {
      state.loadingForms = false;
      state.allFormsRequestDone = false;
    });

    builder.addCase(getRequerimentosPeritos.fulfilled, (state, { payload }) => {
      state.peritos = payload;
    });

    builder.addCase(enviarRequerimentoFormulario.pending, (state) => {
      state.envio.loading = true;
      state.envio.error = '';
    });

    builder.addCase(
      enviarRequerimentoFormulario.fulfilled,
      (state, { payload }) => {
        state.envio.loading = false;
        state.envio.error = '';
        state.protocolo = payload.protocolo;
        state.envio.lastProtocolo = payload.protocolo;
        state.envio.lastFormulario = payload.formulario;
        state.allFormsRequestDone = false;
      }
    );

    builder.addCase(
      enviarRequerimentoFormulario.rejected,
      (state, { payload }) => {
        state.envio.loading = false;
        state.envio.error = payload || 'Erro ao enviar requerimento.';
      }
    );

    [
      criarRascunhoRequerimento,
      adicionarItemRascunhoRequerimento,
      atualizarItemRascunhoRequerimento,
      excluirItemRascunhoRequerimento,
      concluirEnvioRequerimento,
    ].forEach((thunk) => {
      builder.addCase(thunk.pending, (state) => {
        state.rascunho.loading = true;
        state.rascunho.error = '';
      });
      builder.addCase(thunk.rejected, (state, { payload }) => {
        state.rascunho.loading = false;
        state.rascunho.error = payload || 'Erro na operação.';
      });
    });

    builder.addCase(
      criarRascunhoRequerimento.fulfilled,
      (state, { payload }) => {
        state.rascunho.loading = false;
        state.protocolo = payload.protocolo;
        state.formularioLista = payload.formularioLista ?? [];
      }
    );

    builder.addCase(
      adicionarItemRascunhoRequerimento.fulfilled,
      (state, { payload }) => {
        state.rascunho.loading = false;
        state.formularioLista =
          payload.formularioLista ?? state.formularioLista;
      }
    );

    builder.addCase(
      atualizarItemRascunhoRequerimento.fulfilled,
      (state, { payload }) => {
        state.rascunho.loading = false;
        state.formularioLista =
          payload.formularioLista ?? state.formularioLista;
      }
    );

    builder.addCase(
      excluirItemRascunhoRequerimento.fulfilled,
      (state, { payload }) => {
        state.rascunho.loading = false;
        state.formularioLista =
          payload.formularioLista ?? state.formularioLista;
      }
    );

    builder.addCase(
      concluirEnvioRequerimento.fulfilled,
      (state, { payload }) => {
        state.rascunho.loading = false;
        state.formularioLista = payload.formularioLista ?? [];
        state.allFormsRequestDone = false;
        state.protocolo = '';
      }
    );
  },
});

export const requerimentos = requerimentosSlice.reducer;
export const { setDadosPessoaisRequerimento } = requerimentosSlice.actions;
